import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Footer from '../components/Footer';
import './StaticPages.css';

const TermsPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="static-page">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon">🏍️</span>
            <h1>ThaiBike Rent</h1>
          </div>
          <div className="header-right">
            <LanguageSwitcher />
            <div className="contact-header">
              <a href="tel:+66123456789" className="phone">+66 123 456 789</a>
            </div>
          </div>
        </div>
      </header>

      <div className="container static-content">
        <div className="page-header">
          <h1>{t.pageTerms}</h1>
          <p className="effective-date">{t.termsEffective}</p>
        </div>

        <div className="content-section">
          <h2>{t.termsTitle}</h2>
          <p className="intro">{t.termsIntro}</p>
        </div>

        <div className="content-section">
          <h3>{t.termsSection1}</h3>
          <p>{t.termsContent1}</p>
        </div>

        <div className="content-section">
          <h3>{t.termsSection2}</h3>
          <p>{t.termsContent2}</p>
        </div>

        <div className="content-section">
          <h3>{t.termsSection3}</h3>
          <p>{t.termsContent3}</p>
        </div>

        <div className="content-section">
          <h3>{t.termsSection4}</h3>
          <p>{t.termsContent4}</p>
        </div>

        <div className="content-section">
          <h3>{t.termsSection5}</h3>
          <p>{t.termsContent5}</p>
        </div>

        <div className="content-section contact-section">
          <h3>Contact Us</h3>
          <p>{t.termsContact}</p>
        </div>

        <div className="back-home">
          <a href="/" className="btn btn-outline">← Back to Home</a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;